function handleQuickAdd(e) {

  if (e.classList.contains('is-disabled') || e.classList.contains('has-success')) {
    return;
  }

  let selectedProducts = [];
  let qty = 1; 
  let variantId = parseFloat(e.dataset.addToCartVariant); 

  selectedProducts = [{
    id: variantId,
    quantity: qty
  }]

  let formData = {
    'items': selectedProducts
  }

  if (selectedProducts.length > 0) {
    e.classList.add('is-disabled');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((res) => res.json())
    .then((data) => {
      e.classList.remove('is-disabled');
      e.classList.add('has-success');
  
      getCart();

      var success = document.querySelector('[data-drawer-add-success]');
      success.previousElementSibling.classList.add('is-hidden');
      success.classList.remove('is-hidden');

      setTimeout(() => {
        e.classList.remove('has-success');
        success.previousElementSibling.classList.remove('is-hidden');
        success.classList.add('is-hidden');
      }, 3000);
    })
    .catch(err => {
      console.error(err);
    })
  }
}

function getCart() {
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then((res) => res.json())
  .then((data) => {
    if (data.items.length) {
      document.dispatchEvent(
        new CustomEvent('theme:cart:change', {
          bubbles: true,
          detail: { cart: data }
        })
      );
      document.dispatchEvent(
        new CustomEvent('theme:cart:init', {
          bubbles: true
        })
      );
      document.dispatchEvent(
        new CustomEvent("theme:cart:reload", {
          bubbles: true,
        })
      );
    }
  })
  .catch((err) => {
    console.log(err);
  })
}